
                import "css-modules://src_components_inputselect"
                export default {"Main":"_226afb","Input":"_d6f041"}
            